import useAuth from 'lib/hooks/use-auth';

function getMenuActions(plan, options) {
    const {signOut} = options;

    //TODO: show/hide options by plan

    let nav = [
        {
            label: _t.navigation.settings(),
            to: '/settings'
        }
    ];

    nav.push({
        label: _t.global.logout(),
        onClick: signOut.execute
    });

    return nav;
}

export function useMenuActions() {
    const {meta, signOut} = useAuth();
    const plan = meta.data?.plan;
    return getMenuActions(plan, {
        signOut
    });
}
